<template>
  <div>
    <b-alert :show="!!error" variant="danger">{{ error }}</b-alert>

    <NanLoading v-if="isLoading" />

    <b-card v-else class="animated fadeIn">
      <h1 class="mb-5">Pending Licenses</h1>

      <h3 v-if="!tableItems.length">No pending licenses.</h3>

      <b-table
        :items="tableItems"
        :fields="tableFields"
        :current-page="currentPage"
        :per-page="50"
        responsive="lg"
        striped
      >
        <template #cell(type)="{ item }">
          <i :class="productDetails[item.type].icon"></i>
          {{ item.type === "edu" ? "Academic" : item.type | capitalize }}
        </template>

        <template #cell(email)="{ item }">
          {{ item.owner ? item.owner.email : item.org.name }}
        </template>

        <template #cell(expires)="{ item }">{{
          item.expired_time | date
        }}</template>

        <template #cell(actions)>
          <b-btn
            variant="link"
            aria-label="Accept"
            v-b-tooltip.bottom.hover
            title="Accept"
          >
            <i class="text-primary icon-check"></i>
          </b-btn>
          <b-btn
            variant="link"
            aria-label="Reject"
            v-b-tooltip.bottom.hover
            title="Reject"
          >
            <i class="text-danger icon-close"></i>
          </b-btn>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

import API from "@/api";
import productDetails from "@/data/products";

export default {
  metaInfo: {
    titleTemplate: "Pending Licenses - %s"
  },

  data: () => ({
    productDetails,
    isLoading: false,
    error: null,
    tableItems: [],
    tableFields: [
      { key: "type", sortable: true },
      { key: "email", label: "Owner", sortable: true },
      { key: "expires", sortable: true },
      { key: "actions", class: "text-right" }
    ],
    currentPage: 1,
    statusBadges: {
      accepted: "success",
      pending: "warning",
      expired: "danger"
    }
  }),

  computed: {
    ...mapState(["user"])
  },

  async created() {
    this.isEditing = this.$route.query.edit !== undefined;

    try {
      this.isLoading = true;

      const { success, results } = await API.licensesPending();

      if (success) {
        this.tableItems = results.list;
      }
    } catch (err) {
      console.warn(err);
      this.error = "There was an error getting licenses";
    } finally {
      this.isLoading = false;
    }
  }
};
</script>
